import React, { Component, useState, useEffect } from "react";
import "../index.css";
import "./index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter, useHistory } from "react-router-dom";
import "react-phone-number-input/style.css";
import { AiOutlinePlayCircle, AiOutlineRight } from "react-icons/ai";
import { useLoading } from "../Context/LoadingContext";
import { BsPlayCircle } from "react-icons/bs";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { BiRightArrowAlt } from "react-icons/bi";

const Section1Mobile = ({ setIsOpen, requestLoading }) => {
  const [name, setName] = useState("");
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  if (requestLoading === true) {
    return null;
  }

  useEffect(() => {
    setVideos(numberOfVideos);
  }, []);

  const numberOfVideos = [1, 2, 3, 4];

  const items = [
    "9a802u00bjaTVQtW02fdedGV02VTsOEQ900ve02nziwXUZyRY",
    "n52sJPnVS5FLsMsFUyXEqGDCCIyoI02iVpkw4r0000MyVY",
    "OXyVd69dlds801P3GcknjIL5SX1VxKezcoCJ7FizMOOQ",
    "S6jK01b6BAP2m3mRB01uh1yiwrIGoOzNdfl01qA4MpJULQ",
  ];

  const percentage = 66;

  return (
    <>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSBold",
            fontSize: "3.7vw",
            color: "rgb(255, 215, 0)",
            marginTop: 20,
          }}
        >
          Premium Feature
        </p>
      </MDBCol>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSBold",
            fontSize: "5.7vw",
            marginTop: -10,
            textAlign: "center",
            lineHeight: 1.3,
          }}
        >
          Unlock celebrities and <br />
          custom cloning
        </p>
      </MDBCol>
      <MDBCol className="d-flex justify-content-center" size="12">
        <p
          style={{
            display: "inline-block",
            fontFamily: "CSMedium",
            fontSize: "3.6vw",
            textAlign: "center",
            marginTop: -5,
          }}
        >
          Unlock all celebrities, longer videos, custom cloning, watermark-free
          and faster video generator.
        </p>
      </MDBCol>
      <MDBCol
        className="d-flex justify-content-center"
        style={{ cursor: "pointer", marginTop: 10, marginLeft: -10 }}
        size="12"
      >
        <MDBRow style={{ width: "100vw" }}>
          {items.map((item, index) => {
            return (
              <MDBCol size="3">
                <div
                  key={index}
                  style={{
                    position: "relative",
                    display: "inline-block",
                    height: "88vw",
                    width: "50vw",
                    marginRight: 6,
                    borderRadius: 5,
                    overflow: "hidden",
                    marginBottom: 16,
                  }}
                >
                  <img
                    src={`https://image.mux.com/${item}/animated.gif`}
                    style={{
                      display: "inline-block",
                      height: "88vw",
                      width: "50vw",
                      borderRadius: 10,
                      objectFit: "cover",
                      verticalAlign: "top",
                      backgroundColor: "transparent", // Added this line
                      filter: "blur(2px)",
                    }}
                  />
                </div>
              </MDBCol>
            );
          })}
        </MDBRow>
      </MDBCol>
    </>
  );
};

export default withRouter(Section1Mobile);
